<template>
    <div class="form-body">
    <div class="row pagelogin">
      <div class="img-holder">
        <div class="bg"  :style="bannerImages"></div>
        <div class="info-holder"></div>
      </div>
      <div class="form-holder loginpagestyle">
        <div class="container form-content ">
          <div class="form-items toplogin">
            <span class="logo" v-html="logos"></span>
            <h3 class="login-welcome-back" style="margin-top: 15px;">Welcome to screenit</h3>
            <p style="text-align: center;margin-bottom: 10px;font-size: 14px">Sign In to stay updated on all new world.</p>
              <br>
            <div class="con">
              <form v-on:submit.prevent="UserLogin()" method="post">
              <div id="selected" class="btn-grp btnlist" >
              <button  class="btn btn-dark target" v-bind:class="{ 'active': login.type_of_account == 'individual' }" @click.prevent="Interviewer()"><i class="fa fa-user" aria-hidden="true"></i> Interviewer</button>
              <button class="btn btn-dark target" v-bind:class="{ 'active': login.type_of_account == 'candidate' }" @click.prevent="Candidate()"><i class="fa fa-user-o" aria-hidden="true"></i> Candidate</button>
              </div>
              <br>
              <label for="exampleInputEmail1">Email</label>
              <input
                v-model="login.user_email"
                @keyup="clear()"
                type="email"
                class="form-control inputfield"
                id="email"
                name="email"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                :class="{ 'is-invalid': submitted && $v.login.user_email.$error }"
              />
              <div
                  v-if="submitted && $v.login.user_email.$error"
                  class="invalid-feedback errorMsgstyle"
                >
                  <span v-if="!$v.login.user_email.required" class="error-msg" >User email is required*</span>
                  <span v-if="!$v.login.user_email">Email is invalid*</span>
                </div>
                <div class="invalid-feedback errorMsgstyle">
                  <span v-if="errormsg == 'Invalid EmailID'" class="error-msg">Email is invalid*</span>
                </div>
            <div class="form-group">
              <div class="form-label-group form-forgot-password">
                  <div class="form-group has-feedback errorMsgstyle">
                    <label for="exampleInputPassword1">Password</label>
                    <input
                    name="user_password"
                    id="user_password"
                      :type="passwordFieldType"
                      @keyup="clear()"
                      class="form-control cleardefault"
                      placeholder="Password"
                      minlength="8"
                      :class="{ 'is-invalid': submitted && $v.login.user_password.$error }"
                      v-model="$v.login.user_password.$model"/>
                    <span class="uil uil-eye form-control-feedback"
                      v-if="passwordFieldType == 'text'"
                      @click="switchVisibility"></span>
                    <span class="uil uil-eye-slash form-control-feedback" style="top:30px"
                      v-if="passwordFieldType == 'password'"
                      @click="switchVisibility"></span>
                    <div v-if="$v.login.user_password.$error">
                      <span v-if="!$v.login.user_password.required" class="error-msg">Enter the password*</span>
                    </div>
                    <div>
                      <p v-if="errormsg == 'Invalid Password'" class="error-msg">* {{errormsg}}</p>
                    </div>
                  </div>
                </div>
                <br>
                <div class="forgetpsswd">
          <!-- <router-link to="/forgotPasswordPage" class="btn" style="color:#5bad2b">
            Forgot Password?</router-link> -->
            <button class="btn" style="color:#5bad2b;background:transparent" @click="forgotPasswordPage()">Forgot Password?</button>
        </div>
            </div>
                <br>
            <div class="signinbtn">
              <button type="submit" class="btn btn-success" style="width:100%">Sign In</button>
              </div>
              </form>
              <br>
              <h2 class="otherLogin"><span class="otherLogin1">SOCIAL LOGIN</span></h2>
              <div class="socialLogin">
              <button type="submit" class="btn socialbtn" @click="googleLogin()"><i class="fa fa-google google" aria-hidden="true" ></i></button>
              <button type="submit" class="btn socialbtnf" ><i class="fa fa-facebook facebook" aria-hidden="true"></i></button>
              <!-- <i style="color:#DB4437" class="fa fa-google" aria-hidden="true" @click="googleLogin()"></i>
              <i  style="color:#4267B2" class="fa fa-facebook facebook" aria-hidden="true"></i> -->

              </div>

              <br>
              <div class="signup">
              <small>New to Screenit? <span style="color:#5bad2b"><router-link to="/RegistrationPage" class="btn"
              >Sign Up</router-link></span>
              </small>
              </div>
              </div>
              </div>
              </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Vuelidate from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import Vue from 'vue'
import bannerImage from '../../assets/img/login-image.jpg'
import { logo } from '../../shared/svg'
import { BaseURL } from '../../shared/classes'
import firebase from 'firebase'
import { getAuth, signOut } from 'firebase/auth'
// import $ from 'jquery'
// import VueAxios from 'vue-axios'
// import VueSocialauth from 'vue-social-auth'
// Vue.prototype.$http = axios
import momentsone from 'moment-timezone'
Vue.use(Vuelidate, axios)
// Vue.use(VueAxios, axios)
// Vue.use(VueSocialauth, {

//   providers: {
//     google: {
//       clientId: '193926843799-khthvb2liudgch1gblgn7dfq6t589139.apps.googleusercontent.com',
//       client_secret: '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',
//       auth_uri: 'https://accounts.google.com/o/oauth2/auth',
//       token_uri: 'https://oauth2.googleapis.com/token',
//       redirectUri: 'https://demo.screenit.io/auth/google/callback' // Your client app URL
//     }
//   }
// })
const firebaseConfig = {
  apiKey: 'AIzaSyBWbg0J0OQSctDgM6ad7tdduy3Ll2scb7U',
  authDomain: 'maximal-plate-352805.firebaseapp.com',
  projectId: 'maximal-plate-352805',
  storageBucket: 'maximal-plate-352805.appspot.com',
  messagingSenderId: '353297084202',
  appId: '1:353297084202:web:1d6719e91ab7208df93853',
  measurementId: 'G-GFFRDB1CE9'
}
firebase.initializeApp(firebaseConfig)
export default {
  name: 'LoginPage',
  data () {
    return {
      login: {
        user_email: '',
        user_password: '',
        type_of_account: 'individual',
        device_token: '',
        firstName: ''

      },
      user_id: '',
      currentTimeZone: momentsone.tz.guess(),
      token: '',
      availabilitystatus: '',
      timezone: '',
      userinfo: '',
      bannerImages: `background-image: url(${bannerImage})`,
      logos: logo,
      submitted: false,
      passwordFieldType: 'password',
      errormsg: '',
      googleUseremail: '',
      googleTypeofaccount: '',
      googleFirstname: ''
      // userDetails: ''
    }
  },
  validations: {
    login: {
      user_email: { required, email },
      user_password: { required, minLength: minLength(8) }
    }
  },
  created () {
    this.Interviewer()
    localStorage.clear()
  },
  methods: {
    getZone (userid) {
      let time = ''
      if (this.currentTimeZone === 'America/New_York') {
        time = 'EST'
      } else {
        time = 'IST'
      }
      const formData = new FormData()
      formData.append('timezone', time)
      const data = {
        timezone: time
      }
      axios.post(BaseURL + '/profile/update_user_timezone/' + userid, { formData: data }).then(response => {
        console.log(response)
        this.$awn.success('Login Successfull')
        this.$router.push('/scheduleAvailability/' + userid)
      })
    },
    clear () {
      this.errormsg = ''
    },
    Interviewer () {
      this.login.type_of_account = 'individual'
      localStorage.setItem('type_of_account', this.login.type_of_account)
    },
    Candidate () {
      this.login.type_of_account = 'candidate'
      localStorage.setItem('type_of_account', this.login.type_of_account)
    },
    switchVisibility () {
      this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    UserLogin () {
      this.submitted = true
      const formData = new FormData()
      formData.append('user_email', this.login.user_email)
      formData.append('user_password', this.login.user_password)
      formData.append('type_of_account', this.login.type_of_account)
      const data = {
        user_email: this.login.user_email.toLowerCase(),
        user_password: this.login.user_password,
        type_of_account: this.login.type_of_account
        // device_token: JSON.parse(localStorage.getItem('token'))
      }
      // console.log(this.login.user_email)
      // console.log(this.login.user_password)
      axios.post(BaseURL + '/login', { formData: data })
        .then(response => {
          this.user_id = response.data.userdetail._id
          this.token = response.data.token
          this.availabilitystatus = response.data.userdetail.availabilitystatus
          this.usertimezone = response.data.userdetail.timezone
          // this.userDetails = response.data.userdetail
          console.log(this.userDetails)
          // this.userinfo = this.response.message
          // console.log(this.userinfo)
          localStorage.clear()
          localStorage.setItem('user_email', this.login.user_email)
          // localStorage.setItem('user_password', this.login.user_password)
          localStorage.setItem('type_of_account', this.login.type_of_account)
          if (response.data.message === 'Invalid Password' || response.data.message === 'Invalid EmailID') {
            this.errormsg = response.data.message
          } else {
            localStorage.setItem('user__details', JSON.stringify(response.data.userdetail))
            localStorage.setItem('token', this.token)
            localStorage.setItem('user_id', response.data.userdetail._id)
            // let time = ''
            // if (this.currentTimeZone === 'America/New_York') {
            //   time = 'EST'
            // } else {
            //   time = 'IST'
            // }
            // if (response.data.userdetail.timezone === time) {
            //   this.$awn.success('Login Successfull')
            //   this.$router.push('/JobPost/' + this.user_id)
            // } else {
            //   this.getZone(this.user_id)
            // }
            this.$awn.success('Login Successfull')
            this.$router.push('/JobPost/' + this.user_id)
          }
        })
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {

      }
    },
    forgotPasswordPage () {
      localStorage.setItem('type_of_account', this.login.type_of_account)
      localStorage.setItem('token', this.token)
      this.$router.push('/forgotPasswordPage')
    },
    googleLogin () {
      const provider = new firebase.auth.GoogleAuthProvider()
      provider.addScope('email')
      firebase.auth().signInWithPopup(provider).then(response => {
        console.log(response)
        this.googleUseremail = response.additionalUserInfo.profile.email
        this.googleFirstname = response.additionalUserInfo.profile.given_name
        this.googleTypeofaccount = this.login.type_of_account
        this.mylogin()
        // this.$router.push('/scheduleAvailability/' + this.user_id)
        // alert('Login Successfull')
      })
      // window.location.href = BaseURL + '/googleLogin'
    },
    googlelogout () {
      const auth = getAuth()
      signOut(auth).then(() => {
        // Sign-out successful.
      }).catch(() => {
        // An error happened.
      })
    },
    mylogin () {
      const formData = new FormData()
      formData.append('user_email', this.googleUseremail)
      formData.append('type_of_account', this.googleTypeofaccount)
      formData.append('device_token', this.login.device_token)
      formData.append('firstName', this.googleFirstname)

      const data = {
        user_email: this.googleUseremail.toLowerCase(),
        type_of_account: this.googleTypeofaccount,
        firstName: this.googleFirstname,
        device_token: this.login.device_token
      }
      axios.post(BaseURL + '/email/login_with_google/mobile', { formData: data })
        .then(response => {
          this.user_id = response.data.userdetail._id
          this.token = response.data.token
          this.availabilitystatus = response.data.userdetail.availabilitystatus
          this.usertimezone = response.data.userdetail.timezone
          // this.userDetails = response.data.userdetail
          // console.log(this.userDetails)
          // this.userinfo = this.response.message
          // console.log(this.userinfo)
          localStorage.clear()
          localStorage.setItem('user_email', this.googleUseremail)
          // localStorage.setItem('user_password', this.login.user_password)
          localStorage.setItem('type_of_account', this.googleTypeofaccount)
          if (response.data.message === 'Invalid Password' || response.data.message === 'Invalid EmailID') {
            this.errormsg = response.data.message
          } else {
            localStorage.setItem('user__details', JSON.stringify(response.data.userdetail))
            localStorage.setItem('token', this.token)
            localStorage.setItem('user_id', response.data.userdetail._id)
            let time = ''
            if (this.currentTimeZone === 'America/New_York') {
              time = 'EST'
            } else {
              time = 'IST'
            }
            if (response.data.userdetail.timezone === time) {
              this.$awn.success('Login Successfull')
              this.$router.push('/scheduleAvailability/' + this.user_id)
            } else {
              this.getZone(this.user_id)
            }
          }
        })
    },
    // social login
    // AuthProvider (provider) {
    //   var self = this
    //   this.$auth.authenticate(provider).then(response => {
    //     console.log(response)
    //     self.SocialLogin(provider, response)
    //   }).catch(err => {
    //     console.log({ err: err })
    //   })
    // },

    SocialLogin (provider, response) {
      const formData = new FormData()
      formData.append('user_email', this.login.user_email)
      formData.append('type_of_account', this.login.type_of_account)
      formData.append('device_token', this.login.device_token)
      formData.append('firstName', this.login.firstName)

      const data = {
        user_email: this.login.user_email.toLowerCase(),
        type_of_account: this.login.type_of_account,
        firstName: this.login.firstName,
        device_token: this.login.device_token
      }
      axios.post(BaseURL + '/email/login_with_google/mobile' + provider, response, { formData: data }).then(response => {
        console.log(response)
      }).catch(err => {
        console.log({ err: err })
      })
    }
  },
  mounted: function () {
    // function myFunction (e) {
    //   var elems = document.querySelectorAll('.active');
    //   [].forEach.call(elems, function (el) {
    //     el.classList.remove('active')
    //   })
    //   e.target.className = 'active'
    // }
  }
}
</script>

<style lang="scss" scoped>
.eyeslash{
  top: 30px;
  }
.toplogin{
 margin-top: 0%;
}
.loginpagestyle{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left:20%

}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
}
.login {
  column-count: 2;
}
.formdatapage {
  width: 70%;
  height: auto;
  // padding-top: 100%;
}
#bnrimg {
  width: 100%;
  height: 650px;
  max-width: 400px;
}
.signinbtn{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;

}
.signup{
  display: flex;
  justify-content: center;
}
.welcometitle{
  text-align: center;
}
.btnlist{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.btnlist>button {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 18px;
}
.btnlist>button:hover {
    color: #fff;
    background-color: #5bad2b;
}
.btnlist>button:focus {
    color: #fff;
    background-color: #5bad2b;
}
.btnlist>.active>button:active {
    color: #fff;
    background-color: #5bad2b;
}
.btnlist>.active>button {
    color: #fff;
    background-color: #5bad2b;
}
#selected>button.active{
  background-color: #5bad2b;
  color: #fff;
}
.forgetpsswd{
  display: flex;
  justify-content: flex-end ;
}
.field-icon {
float: right;
  margin-left: -25px;
  margin-top: -25px;
  position: relative;
  z-index: 1;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
.loginpagestyle{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
   margin-top: 20px;
   padding: 20px;
   margin:0%;

}
.btnlist{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.btnlist>button {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 12px;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%
}
.eyeicon{
  top:30px
}
.toplogin{
  margin:25px;
}
}
  @media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
    .pagelogin{
      display: flex;
      justify-content: center;
    }
.loginpagestyle{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
   margin-top: 20px;
   padding: 20px;
   margin: 0%;

}
.btnlist{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.btnlist>button {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 12px;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%
}
// .container{
//    width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
.bg{
    display: none;
}
}

@media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
.loginpagestyle{
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
   margin-top: 20px;

}
.container{
  //  width: 100%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  margin-left: 10%;
}
.bg{
  width:80%
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%
}
}
.errorMsgstyle{
text-align: left;
}
.socialLogin{
  font-size: 30px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
}
.otherLogin{
   width: 100%;
   text-align: center;
   border-bottom: 1px solid #000;
   line-height: 0.1em;
   margin: 10px 0 20px;
}
.otherLogin .otherLogin1{
    padding:0 10px;
}
.socialbtn{
width: 50px;
height: 50px;
background: #DB4437;
color:snow;
border-radius: 5px;
border: none;
margin-bottom: 10px;
margin-left: 5px;
margin-right: 5px;
font-size: 25px;
cursor: pointer;

& .google{
  background-color: #DB4437 ;
}

}

.socialbtnf{
width: 50px;
height: 50px;
background: #4267B2;
color:snow;
border-radius: 5px;
border: none;
margin-bottom: 10px;
margin-left: 5px;
margin-right: 5px;
font-size: 23px;
cursor: pointer;
& .facebook{
  background: #4267B2;
}
}
</style>
